import { ISearchOption } from 'types/propertyAttributes'
import { PropertyAdStatus } from './types'
import { PROPERTY_AD_STATUS } from 'helpers/constants'

export type PropertyAdStatusOption = ISearchOption<PropertyAdStatus>

export const PROPERTY_AD_STATUS_OPTIONS: PropertyAdStatusOption[] = [
  {
    label: 'tables.propertyAds.status.active',
    value: PROPERTY_AD_STATUS.STATUS_ACTIVE,
  },
  {
    label: 'tables.propertyAds.status.inactive',
    value: PROPERTY_AD_STATUS.STATUS_INACTIVE,
  },
]

export const ADMIN_PROPERTY_AD_STATUS_OPTIONS: PropertyAdStatusOption[] = [
  {
    label: 'tables.propertyAds.status.active',
    value: PROPERTY_AD_STATUS.STATUS_ACTIVE,
  },
  {
    label: 'tables.propertyAds.status.inactive',
    value: PROPERTY_AD_STATUS.STATUS_INACTIVE,
  },
  {
    label: 'tables.propertyAds.status.deleted',
    value: PROPERTY_AD_STATUS.STATUS_DELETED,
  },

  {
    label: 'tables.propertyAds.status.invalid',
    value: PROPERTY_AD_STATUS.STATUS_INVALID,
  },
]

export const estateExtrasMap = new Map([
  ['air_condition', 'airCondition'],
  ['air_condition_no', 'airCondition'],
  ['alarm', 'alarm'],
  ['alarm_no', 'alarm'],
  ['balcony', 'balcony'],
  ['balcony_no', 'balcony'],
  ['cctv', 'cctv'],
  ['cctv_no', 'cctv'],
  ['corner', 'corner'],
  ['corner_no', 'corner'],
  ['disabled_access', 'disabledAccess'],
  ['disabled_access_no', 'disabledAccess'],
  ['double_frontage', 'doubleFrontage'],
  ['double_frontage_no', 'doubleFrontage'],
  ['elevator', 'elevator'],
  ['elevator_no', 'elevator'],
  ['facade', 'facade'],
  ['facade_no', 'facade'],
  ['fireplace', 'fireplace'],
  ['fireplace_no', 'fireplace'],
  ['furnished', 'furnished'],
  ['furnished_no', 'furnished'],
  ['intercom', 'intercom'],
  ['intercom_no', 'intercom'],
  ['loft', 'loft'],
  ['loft_no', 'loft'],
  ['maintained', 'maintained'],
  ['maintained_no', 'maintained'],
  ['pets', 'pets'],
  ['pets_no', 'pets'],
  ['penthouse', 'penthouse'],
  ['penthouse_no', 'penthouse'],
  ['professional_use', 'professionalUse'],
  ['professional_use_no', 'professionalUse'],
  ['safe', 'safe'],
  ['safe_no', 'safe'],
  ['screens', 'screens'],
  ['screens_no', 'screens'],
  ['solar_water_heater', 'solarWaterHeater'],
  ['solar_water_heater_no', 'solarWaterHeater'],
  ['storage', 'storage'],
  ['storage_no', 'storage'],
  ['tents', 'tents'],
  ['tents_no', 'tents'],
  ['underfloor_heat', 'underFloorHeat'],
  ['underfloor_heat_no', 'underFloorHeat'],
  ['with_air', 'withAir'],
  ['with_air_no', 'withAir'],
  ['with_light', 'withLight'],
  ['with_light_no', 'withLight'],
  ['maintenance_fees', 'maintenanceFees'],
  ['maintenance_fees_no', 'maintenanceFees'],
  ['renovated', 'renovation'],
  ['renovated_no', 'renovation'],
])

export const commercialExtrasMap = new Map([
  ['air_condition', 'airCondition'],
  ['air_condition_no', 'airCondition'],
  ['alarm', 'alarm'],
  ['alarm_no', 'alarm'],
  ['balcony', 'balcony'],
  ['balcony_no', 'balcony'],
  ['amphitheater', 'slopeAmphitheater'],
  ['amphitheater_no', 'slopeAmphitheater'],
  ['car_elevator', 'carElevator'],
  ['car_elevator_no', 'carElevator'],
  ['cargo_elevator', 'cargoElevator'],
  ['cargo_elevator_no', 'cargoElevator'],
  ['cargo_ramp', 'cargoRamp'],
  ['cargo_ramp_no', 'cargoRamp'],
  ['cctv', 'cctv'],
  ['cctv_no', 'cctv'],
  ['cellar', 'cellar'],
  ['cellar_no', 'cellar'],
  ['corner', 'corner'],
  ['corner_no', 'corner'],
  ['disabled_access', 'disabledAccess'],
  ['disabled_access_no', 'disabledAccess'],
  ['doorman', 'doorman'],
  ['doorman_no', 'doorman'],
  ['drains', 'drains'],
  ['drains_no', 'drains'],
  ['elevator', 'elevator'],
  ['elevator_no', 'elevator'],
  ['enclosure', 'enclosure'],
  ['enclosure_no', 'enclosure'],
  ['equipped', 'equipped'],
  ['equipped_no', 'equipped'],
  ['event_space', 'eventSpace'],
  ['event_space_no', 'eventSpace'],
  ['expandability', 'expandability'],
  ['expandability_no', 'expandability'],
  ['facade', 'facade'],
  ['facade_no', 'facade'],
  ['false_ceiling', 'falseCeiling'],
  ['false_ceiling_no', 'falseCeiling'],
  ['fire_safety', 'fireSafety'],
  ['fire_safety_no', 'fireSafety'],
  ['fireplace', 'fireplace'],
  ['fireplace_no', 'fireplace'],
  ['food_service', 'foodService'],
  ['food_service_no', 'foodService'],
  ['furnished', 'furnished'],
  ['furnished_no', 'furnished'],
  ['gas_station', 'gasStation'],
  ['gas_station_no', 'gasStation'],
  ['guarding', 'guarding'],
  ['guarding_no', 'guarding'],
  ['internal_stairs', 'internalStairs'],
  ['internal_stairs_no', 'internalStairs'],
  ['kitchen', 'kitchen'],
  ['kitchen_no', 'kitchen'],
  ['maintained', 'maintained'],
  ['maintained_no', 'maintained'],
  ['meeting_room', 'meetingRoom'],
  ['meeting_room_no', 'meetingRoom'],
  ['organized_beach', 'organizedBeach'],
  ['organized_beach_no', 'organizedBeach'],
  ['outbar', 'outBar'],
  ['outbar_no', 'outbar'],
  ['plot', 'commercialPlot'],
  ['plot_no', 'commercialPlot'],
  ['penthouse', 'penthouse'],
  ['penthouse_no', 'penthouse'],
  ['restaurant', 'restaurant'],
  ['restaurant_no', 'restaurant'],
  ['roof_garden', 'roofGarden'],
  ['roof_garden_no', 'roofGarden'],
  ['safe', 'safe'],
  ['safe_no', 'safe'],
  ['security_rolls', 'securityRolls'],
  ['security_rolls_no', 'securityRolls'],
  ['spa', 'spa'],
  ['spa_no', 'spa'],
  ['sport_fields', 'facilities'],
  ['sport_fields_no', 'facilities'],
  ['staff_rooms', 'staffRooms'],
  ['staff_rooms_no', 'staffRooms'],
  ['structured_wiring', 'structuredWiring'],
  ['structured_wiring_no', 'structuredWiring'],
  ['underfloor_heat', 'underFloorHeat'],
  ['underfloor_heat_no', 'underFloorHeat'],
  ['washing_machine', 'carWash'],
  ['washing_machine_no', 'carWash'],
  ['water_heating', 'waterHeating'],
  ['water_heating_no', 'waterHeating'],
  ['water_supply', 'waterSupply'],
  ['water_supply_no', 'waterSupply'],
  ['maintenance_fees', 'maintenanceFees'],
  ['maintenance_fees_no', 'maintenanceFees'],
  ['renovated', 'renovation'],
  ['renovated_no', 'renovation'],
])

export const landExtrasMap = new Map([
  ['agricultural_use', 'agriculturalUse'],
  ['agricultural_use_no', 'agriculturalUse'],
  ['amphitheater', 'slopeAmphitheater'],
  ['amphitheater_no', 'slopeAmphitheater'],
  ['buildable', 'islandBuildable'],
  ['buildable_no', 'islandBuildable'],
  ['compensation', 'compensation'],
  ['compensation_no', 'compensation'],
  ['corner', 'corner'],
  ['corner_no', 'corner'],
  ['drains', 'drains'],
  ['drains_no', 'drains'],
  ['electrification', 'electrification'],
  ['electrification_no', 'electrification'],
  ['enclosure', 'enclosure'],
  ['enclosure_no', 'enclosure'],
  ['facade', 'facade'],
  ['facade_no', 'facade'],
  ['marina', 'marina'],
  ['marina_no', 'marina'],
  ['view', 'view'],
  ['view_no', 'view'],
  ['water_supply', 'waterSupply'],
  ['water_supply_no', 'waterSupply'],
  ['with_building', 'withBuilding'],
  ['with_building_no', 'withBuilding'],
  ['non_forest', 'nonForest'],
  ['non_forest_no', 'nonForest'],
])

export const propertyMap: Map<
  string,
  {
    id: number
    field?: string
    type: string
    multiple?: boolean
    map?: Map<string, string>
  }
> = new Map([
  ['ESTATE_PROPERTY_TYPE', { id: 1, field: 'subCategory', type: 'TEXT' }],
  [
    'ESTATE_PROPERTY_COMMERCIAL_TYPE',
    { id: 2, field: 'subCategory', type: 'TEXT' },
  ],
  ['ESTATE_PROPERTY_LAND_TYPE', { id: 3, field: 'subCategory', type: 'TEXT' }],
  [
    'ESTATE_PROPERTY_CONDITION',
    { id: 4, field: 'estateCondition', type: 'TEXT' },
  ],
  ['ESTATE_PROPERTY_HEAT', { id: 5, field: 'heat', type: 'TEXT' }],
  [
    'ESTATE_PROPERTY_HEAT_TYPE',
    { id: 6, field: 'heatType', type: 'TEXT', multiple: true },
  ],
  ['ESTATE_PROPERTY_EXTRAS', { id: 7, type: 'TEXT', map: estateExtrasMap }],
  [
    'ESTATE_PROPERTY_COMMERCIAL_EXTRAS',
    { id: 8, type: 'TEXT', map: commercialExtrasMap },
  ],
  [
    'ESTATE_PROPERTY_LAND_TYPE_EXTRAS',
    { id: 9, type: 'TEXT', map: landExtrasMap },
  ],
  ['ESTATE_PROPERTY_BATHROOMS', { id: 10, field: 'baths', type: 'NUMBER' }],
  ['ESTATE_PROPERTY_BEDROOMS', { id: 11, field: 'bedrooms', type: 'NUMBER' }],
  [
    'ESTATE_PROPERTY_FLOOR',
    { id: 12, field: 'floors', type: 'TEXT', multiple: true },
  ],
  [
    'ESTATE_PROPERTY_RENOVATION_YEAR',
    { id: 13, field: 'renovationYear', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_BALCONY_SQR',
    { id: 14, field: 'balconySqr', type: 'NUMBER' },
  ],
  ['ESTATE_PROPERTY_PARKING', { id: 15, field: 'parking', type: 'TEXT' }],
  [
    'ESTATE_PROPERTY_PARKING_SLOTS',
    { id: 16, field: 'parkingSlots', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_GARDEN',
    {
      id: 17,
      field: 'garden',
      type: 'TEXT',
    },
  ],
  [
    'ESTATE_PROPERTY_MAINTENANCE_FEES',
    { id: 18, field: 'maintenanceFeesValue', type: 'NUMBER' },
  ],
  ['ESTATE_PROPERTY_DOOR', { id: 19, field: 'door', type: 'TEXT' }],
  [
    'ESTATE_PROPERTY_ENERGY_CLASS',
    { id: 20, field: 'energyClass', type: 'TEXT' },
  ],
  ['ESTATE_PROPERTY_FRAMES', { id: 21, field: 'frame', type: 'TEXT' }],
  [
    'ESTATE_PROPERTY_LIVING_ROOMS',
    { id: 22, field: 'livingRooms', type: 'NUMBER' },
  ],
  ['ESTATE_PROPERTY_FLOOR_TYPE', { id: 23, field: 'floor', type: 'TEXT' }],
  ['ESTATE_PROPERTY_ACCESS', { id: 24, field: 'access', type: 'TEXT' }],
  ['ESTATE_PROPERTY_VIEW', { id: 26, field: 'view', type: 'TEXT' }],
  [
    'ESTATE_PROPERTY_POOL',
    { id: 27, field: 'pool', type: 'TEXT', multiple: true },
  ],
  ['ESTATE_PROPERTY_ROOMS', { id: 28, field: 'rooms', type: 'NUMBER' }],
  ['ESTATE_PROPERTY_SPACES', { id: 29, field: 'spaces', type: 'NUMBER' }],
  ['ESTATE_PROPERTY_WC', { id: 30, field: 'wc', type: 'NUMBER' }],
  ['ESTATE_PROPERTY_USAGE', { id: 31, field: 'usage', type: 'TEXT' }],
  [
    'ESTATE_PROPERTY_ELECTRICITY_TYPE',
    { id: 32, field: 'electricity', type: 'TEXT' },
  ],
  ['ESTATE_PROPERTY_CONSTRUCTION_TYPE', { id: 33, field: '', type: 'TEXT' }], // MISSING INFORM FIELD FORM
  ['ESTATE_PROPERTY_EQUIPMENT', { id: 35, field: 'equipment', type: 'TEXT' }],
  ['ESTATE_PROPERTY_PLOT_SQR', { id: 36, field: 'plotSqr', type: 'NUMBER' }],
  [
    'ESTATE_PROPERTY_INDUSTRIAL_DOOR_HEIGHT',
    { id: 37, field: 'industrialDoorHeight', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_INDUSTRIAL_DOOR_WIDTH',
    { id: 38, field: 'industrialDoorWidth', type: 'NUMBER' },
  ],
  ['ESTATE_PROPERTY_ENTRANCES', { id: 39, field: 'entrances', type: 'NUMBER' }],
  ['ESTATE_PROPERTY_OFFICES', { id: 40, field: 'offices', type: 'NUMBER' }],
  [
    'ESTATE_PROPERTY_DISTANCE_PORT',
    { id: 41, field: 'distancePort', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_DISTANCE_ROAD_NETWORK',
    { id: 42, field: 'distanceRoadNetwork', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_DISTANCE_AIRPORT',
    { id: 43, field: 'distanceAirport', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_ENTRANCE_HEIGHT',
    { id: 44, field: 'entranceHeight', type: 'NUMBER' },
  ],
  //   ['ESTATE_PROPERTY_AUXILARY_SPACES', {id:45, field: '', type: 'NUMBER' }], // not in store
  [
    'ESTATE_PROPERTY_RESTAURANTS',
    { id: 46, field: 'numberOfRestaurants', type: 'NUMBER' },
  ],
  [
    'ESTATE_LAND_PROPERTY_BUILDING_SQR',
    { id: 47, field: 'withBuildingSqr', type: 'NUMBER' },
  ],
  [
    'ESTATE_LAND_PROPERTY_ALLOWED_HEIGHT',
    { id: 48, field: 'maxAllowedHeight', type: 'NUMBER' },
  ],
  [
    'ESTATE_LAND_FOREST_COVER',
    { id: 49, field: 'forestCover', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_DISTANCE_TOWN',
    { id: 50, field: 'distanceTown', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_DISTANCE_VILLAGE',
    { id: 51, field: 'distanceVillage', type: 'NUMBER' },
  ],
  ['ESTATE_PROPERTY_VIEWS', { id: 52, field: 'numberOfViews', type: 'NUMBER' }],
  [
    'ESTATE_LAND_PROPERTY_FOREST_COVER_SQR',
    { id: 53, field: 'forestCoverSqr', type: 'NUMBER' },
  ],
  ['ESTATE_LAND_PROPERTY_CITY_PLAN', { id: 54, field: 'plan', type: 'TEXT' }],
  [
    'ESTATE_PROPERTY_INDEPENDET_AREAS',
    { id: 55, field: 'independentSpaces', type: 'NUMBER' },
  ],
  ['ESTATE_PARKING_SLOTS_CAR', { id: 56, field: 'slotsCar', type: 'NUMBER' }],
  [
    'ESTATE_PARKING_SLOTS_BIKE',
    { id: 57, field: 'slotsMotorcycle', type: 'NUMBER' },
  ],
  ['ESTATE_PARKING_SLOTS_BOAT', { id: 58, field: 'slotsBoat', type: 'NUMBER' }],
  [
    'LAND_CONDITION',
    { id: 59, field: 'landCondition', type: 'TEXT', multiple: true },
  ],
  ['ESTATE_PROPERTY_WINDOWS_TYPE', { id: 60, field: 'windows', type: 'TEXT' }],
  ['ESTATE_PROPERTY_DIRECTION', { id: 61, field: 'direction', type: 'TEXT' }],
  [
    'ESTATE_PROPERTY_GARDEN_SQR',
    { id: 62, field: 'gardenSqr', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_WAREHOUSE_SQR',
    { id: 63, field: 'storageSqr', type: 'NUMBER' },
  ],
  ['ESTATE_PROPERTY_LOFT_SQR', { id: 64, field: 'loftSqr', type: 'NUMBER' }],
  [
    'ESTATE_PROPERTY_DISTANCE_SEA',
    { id: 65, field: 'distanceSea', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_MASTER_BEDROOMS',
    { id: 66, field: 'masterBedrooms', type: 'NUMBER' },
  ],
  [
    'ESTATE_LAND_PROPERTY_PLOT_WIDTH',
    { id: 69, field: 'plotWidth', type: 'NUMBER' },
  ],
  [
    'ESTATE_LAND_PROPERTY_PLOT_LENGTH',
    { id: 70, field: 'plotLength', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_EXPANDABLE_SQR',
    { id: 73, field: 'expandabilitySqr', type: 'NUMBER' },
  ],
  [
    'ESTATE_PROPERTY_CARGO_ELEVATOR_WEIGHT',
    { id: 74, field: 'cargoElevatorLoad', type: 'NUMBER' },
  ],
  [
    'ESTATE_LAND_PROPERTY_ISLAND_PERIMETER',
    { id: 76, field: 'islandPerimeter', type: 'NUMBER' },
  ],
  [
    'ESTATE_LAND_PROPERTY_NUM_OF_BEACHES',
    { id: 77, field: 'beaches', type: 'NUMBER' },
  ],
  // ['ESTATE_PROPERTY_NUM_OF_FIREPLACES', { id: 78, field: '', type: 'NUMBER' }], // missing in store,to be added
  // ['ESTATE_PROPERTY_NUM_OF_KITCHENS', { id: 79, field: '', type: 'NUMBER' }], // missing in store,to be added
  ['ESTATE_PROPERTY_NUM_OF_GYMS', { id: 80, field: 'gyms', type: 'NUMBER' }],
])

export const PropertyAdTemplate = {
  id: null,
  externalId: null,
  titles: [],
  descriptions: [],
  estateAgent: null,
  agentCInfo: null,
  adCategory: {
    id: null,
  },
  properties: [
    {
      id: null,
      location: {
        addresses: [],
      },
      propertyAttributes: [],
    },
  ],
  status: '',
  salesPrice: '',
  attachments: [],
}
